import PropTypes from 'prop-types';
import AddIcon from '../../../assets/svg/add.svg?react';
import SubtractIcon from '../../../assets/svg/subtract.svg?react';
import classNames from 'classnames';
import styles from './FJGenerateQuantity.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import { MAX_GENERATE_NUM } from '../../../config/dataConfig/FJImageToImageData';
const FJGenerateQuantity = props => {
    const { generateQuantity, onAdd, onSubtract } = props;

    const isSubtractDisabled = generateQuantity === 1;
    const isAddDisabled = generateQuantity === MAX_GENERATE_NUM;
    return (
        <div className={styles.generated_quantity}>
            <div className={styles.generated_quantity_title}>{FJLocalStore._('quantity')}</div>
            <div className={styles.quantity_box}>
                <SubtractIcon
                    className={classNames(styles.quantity_icon, isSubtractDisabled ? styles.disabled : '')}
                    onClick={onSubtract}
                />
                <span className={styles.quantity_num}>{generateQuantity}</span>
                <AddIcon
                    className={classNames(styles.quantity_icon, isAddDisabled ? styles.disabled : '')}
                    onClick={onAdd}
                />
            </div>
        </div>
    );
};

FJGenerateQuantity.propTypes = {
    generateQuantity: PropTypes.number,
    onAdd: PropTypes.func,
    onSubtract: PropTypes.func,
};
export default FJGenerateQuantity;
